import { base64ToArray, cryptoPairsFromArray, decryptWithRsaBlockCipher, encryptionKeyPairFromArray, verifyRsa, } from '@lucidlink/ts-crypto/crypto';
import { TimeCachedValue } from '#sdk/utils/time-cached-value';
import { SsoCrypto } from './sso-crypto';
import { InvalidCryptoError } from './workspace-crypto.error';
export class AdminCrypto {
    adminMember;
    memberCrypto;
    logger;
    constructor(adminMember, memberCrypto, logger) {
        this.adminMember = adminMember;
        this.memberCrypto = memberCrypto;
        this.logger = logger;
        this.logger = this.logger.child({ class: 'AdminCrypto' });
    }
    async getSsoCrypto() {
        return this.ssoCrypto.get();
    }
    verifyAndGetAdminKeys() {
        return this.adminKeys.get();
    }
    async getWorkspaceCommonKeyArray() {
        return this.memberCrypto.getWorkspaceCommonKeyArray();
    }
    async getWorkspaceCommonKey() {
        await this.adminMember.get();
        return this.memberCrypto.getWorkspaceCommonKey();
    }
    verifyAndGetEveryoneKeys() {
        return this.everyoneKeys.get();
    }
    getCurrentMemberForLogging(additionalLoggingParam = {}) {
        return this.memberCrypto.getCurrentMemberForLogging(additionalLoggingParam);
    }
    async verifyPublicPrivateKeyPair(pair, errorText, additionalLoggingParam) {
        return this.memberCrypto.verifyPublicPrivateKeyPair(pair, errorText, additionalLoggingParam);
    }
    adminKeys = new TimeCachedValue(async () => {
        await this.isAdminPublicKeyVerified.get();
        const adminMember = await this.adminMember.get();
        const memberKeys = await this.memberCrypto.verifyAndGetCurrentMemberKeys();
        const adminPrivateKeyArray = await decryptWithRsaBlockCipher(adminMember.eAdminPrivateKeyByMemberKey, memberKeys.encryptPair.privateKey);
        const adminPublicKeyArray = base64ToArray(adminMember.workspace.adminPublicKey);
        const adminKeys = await cryptoPairsFromArray(adminPublicKeyArray, adminPrivateKeyArray);
        await this.memberCrypto.verifyPublicPrivateKeyPair(adminKeys.signPair, 'Admin public and private key do not match');
        return adminKeys;
    });
    everyoneKeys = new TimeCachedValue(async () => {
        const adminMember = await this.adminMember.get();
        const everyonePublicKeyArray = base64ToArray(adminMember.workspace.everyonePublicKey);
        const invitationKeys = await this.memberCrypto.verifyAndGetCurrentMemberInvitationKeys();
        const everyonePrivateKeyArray = await decryptWithRsaBlockCipher(adminMember.invitation.eEveryonePrivateKeyByInvitationKey, invitationKeys.encryptPair.privateKey);
        const everyoneKeys = await encryptionKeyPairFromArray(everyonePublicKeyArray, everyonePrivateKeyArray);
        await this.memberCrypto.verifyPublicPrivateKeyPair(everyoneKeys, 'Everyone public and private key do not match');
        return everyoneKeys;
    }, { expirationTime: 'neverExpire' });
    isAdminPublicKeyVerified = new TimeCachedValue(async () => {
        const adminMember = await this.adminMember.get();
        let isAdminPublicKeyVerified = false;
        try {
            const invitationKeys = await this.memberCrypto.verifyAndGetCurrentMemberInvitationKeys();
            const adminPublicKeyArray = base64ToArray(adminMember.workspace.adminPublicKey);
            const sAdminPublicKeyByInvitationKeyArray = base64ToArray(adminMember.invitation.sAdminPublicKeyByInvitationKey);
            isAdminPublicKeyVerified = await verifyRsa(adminPublicKeyArray, sAdminPublicKeyByInvitationKeyArray, invitationKeys.signPair.publicKey);
        }
        catch (err) { }
        if (!isAdminPublicKeyVerified) {
            const reason = 'Could not verify admin public key signature';
            this.logger.error({ workspaceId: adminMember.workspace.id }, reason);
            throw new InvalidCryptoError(reason);
        }
        return true;
    });
    ssoCrypto = new TimeCachedValue(async () => {
        const adminMember = await this.adminMember.get();
        if (!adminMember.ssoCrypto) {
            throw new Error(`Missing SSO crypto for member ${adminMember.id}`);
        }
        return new SsoCrypto(this.adminKeys, adminMember.workspace.id, adminMember.ssoCrypto, this.logger);
    }, {
        expirationTime: 'neverExpire',
    });
}
